<template>
    <v-container fluid>
      <div v-if="isCliente == 0">
        <section class="content-header">
          <v-toolbar dark dense color="#96298A">
            <v-toolbar-title>Actualización Masiva de Estatus (Compras en Línea)</v-toolbar-title>
          </v-toolbar>
        </section>
          <v-card elevation="24" outlined>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="12" md="3">
                    <v-card height="100%" elevation="24" outlined shaped>
                      <v-card-title>Seleccionar guias a Agregar</v-card-title>
                      <v-card-text>
                        <v-text-field
                        v-model="searchGuiaAdd"
                        ref="searchGuiaAdd"
                        clearable
                        label="Escanee o ingrese Guía (presione Enter)"
                        append-icon="mdi-earth"
                        @keyup.enter="addGuiaList()"
                        ></v-text-field>
                      </v-card-text>
                      <!--v-card-actions>
                        <v-spacer></v-spacer
                        ><v-btn
                          dark
                          small
                          color="light-blue darken-4"
                          @click="addGuiaList()"
                          outlined
                          >Agregar <v-icon>mdi-arrow-right-box</v-icon></v-btn
                        >
                      </v-card-actions-->
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-card height="100%" elevation="24" outlined shaped>
                      <v-card-title>Guias</v-card-title>
                      <v-card-text>
                        <v-data-table
                          :headers="headersGR"
                          :items="guiasLst"
                          item-key="guia_hija"
                          class="elevation-1"
                        >
                          <template v-slot:item.acciones="{ item }">
                            <v-tooltip bottom color="#96298A">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  color="red"
                                  @click="deletegrs(item)"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>Eliminar</span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="12" md="5">
                      <v-card height="100%" elevation="24" outlined shaped>
                          <v-card-title>Estatus</v-card-title>
                          <v-card-text>
                              <v-row>
                                  <v-col>
                                      <v-combobox
                                          v-model="estatus"
                                          :items="lstEstatus"
                                          label="Estatus"
                                          required
                                          :rules="[reglas.requeridoTxt]"
                                          item-value="id"
                                          item-text="descripcion"
                                          :disabled="disabled"
                                          return-object
                                          @change="handleChangeEstatus()"
                                      ></v-combobox>
                                  </v-col>
                              </v-row>
                              <v-row>
                                  <v-col>
                                      <v-text-field
                                      type="date"
                                      v-model="fecha"
                                      label="Fecha"
                                      required
                                      :rules="[reglas.requeridoTxt]"
                                      >
                                      </v-text-field>
                                  </v-col>
                              </v-row>
                              <v-row>
                                  <v-col>
                                      <v-text-field
                                      type="time"
                                      v-model="hora"
                                      label="Hora"
                                      required
                                      :rules="[reglas.requeridoTxt]"
                                      >
                                      </v-text-field>
                                  </v-col>
                              </v-row>
                              <v-row>
                                  <v-col>
                                      <v-textarea
                                          label="Comentarios"
                                          v-model="comentarios"
                                          append-icon="mdi-file-edit"
                                          ></v-textarea>
                                  </v-col>
                              </v-row>
                              <div v-if="podFlag">
                                <v-subheader>Información de POD</v-subheader>
                                <v-row>
                                  <v-col>
                                      <v-text-field
                                          label="Persona que Recibe"
                                          v-model="pod_nombre"
                                          append-icon="mdi-file-edit"
                                          ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col>
                                      <v-text-field
                                          label="DNI"
                                          v-model="pod_dni"
                                          append-icon="mdi-card"
                                          ></v-text-field>
                                  </v-col>
                                </v-row>
                              </div>
                          </v-card-text>
                      </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" @click="saveItem()" outlined>
                Guardar
                <v-icon dark>mdi-content-save</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
      </div>
      <div v-else>
        <h1>Usted no tiene permisos para ver esta sección</h1>
      </div>
    </v-container>
  </template>
  <script>
  import apicon from "../plugins/apicon";
  import Waiting from "../components/Waiting.vue";
  export default {
    components: {
      Waiting,
    },
    created: function () {},
    data() {
      return {
        search: null,
        overlay: false,
        fullScreen: true,
        searcher: "",
        valid: true,
        guiasAdd: [],
        guiaAdd: null,
        searchGuiaAdd: null,
        guiasLst: [],
        headersGR: [
          { text: "Guia", value: "guia_hija" },
          { text: "Acciones", value: "acciones", align: "end", sortable: false },
        ],
        /*Variables*/
        fecha: null,
        hora: null,
        comentarios: null,
        pod_dni: null,
        pod_nombre: null,
        /*Variables*/
        isCliente: 1,
        lstEstatus: [],
        estatus: null,
        podFlag : false,
      };
    },
    watch: {
    },
    methods: {
      //Agregar guia a lista
      addGuiaList:async function () {
        let flag = await this.verificarGuiaExiste(this.searchGuiaAdd);
        if(flag){
          var guiaA = {
            id: 0,
            id_guia: this.guiaAdd.id,
            guia_hija: this.guiaAdd.guia_hija,
          };
          this.guiasLst.push(guiaA);
          this.guiaAdd = null;
          this.searchGuiaAdd = null;
          this.$refs.searchGuiaAdd.focus();
        }else{
          this.$swal("Guía No Existe");
        }
      },
      deletegrs: function (item) {
        var self = this;
        this.$swal(this.dswalEliminar).then((resultdlg) => {
          if (resultdlg.value) {
              self.guiasLst.splice(
                self.guiasLst.findIndex(
                  (g) => g.guia_hija === item.guia_hija
                ),
                1
              );
          }
        });
      },
      verificarGuiaExiste: async function (guia) {
        let flag = false;
        await apicon
          .getDataApi(apicon.getApiBaseUrl() + "verificarguiaclexiste/" + guia)
          .then((result) => {
            if (result.status) {
              flag = true;
              this.guiaAdd = result.guia;
            }
          });
        return flag;
      },
      //Guardar o Actualizar
      saveItem: async function () {
        if (this.$refs.form.validate()) {
          if(this.guiasLst.length > 0){
            let lstGuias = JSON.stringify(this.guiasLst);
            //Guardar
            this.overlay = true;
            await apicon
              .saveDataApi(apicon.getApiBaseUrl() + "actualizarestatusguiascl", {
                id_estatus : this.estatus.id,
                fecha: this.fecha,
                hora: this.hora,
                comentarios : this.comentarios,
                pod_nombre : this.pod_nombre,
                pod_dni : this.pod_dni,
                pod_fecha : this.estatus.codigo === 'OK' ? this.fecha : null,
                pod_hora : this.estatus.codigo === 'OK' ? this.hora : null,
                guias : lstGuias
              })
              .then((result) => {
                console.log(result);
              });
            this.overlay = false;
            this.$swal("Completado");
            this.limpiar();
          }else{
            this.$swal("Por favor ingrese las guias a las cuales actualizar Estatus");
          }
        }
      },
      limpiar: function(){
        this.guiaAdd = null;
        this.guiasLst = [];
        this.estatus = null;
        this.fecha = null;
        this.hora = null;
        this.comentarios = null;
        this.podFlag = false;
        this.pod_dni = null;
        this.pod_nombre = null;
      },
      getLstEstatus: function () {
        apicon
          .getDataApi(apicon.getApiBaseUrl() + 'estatusall')
          .then((result) => {
            this.lstEstatus = result
          })
      },
      handleChangeEstatus: function(){
        if(this.estatus.codigo === 'OK'){
          this.podFlag = true;
        }else{
          this.podFlag = false;
        }
      }
    },
    mounted() {
      apicon.setAuthHeaders();
      this.getLstEstatus();
      this.isCliente = localStorage.getItem("cliente");
    },
  };
  </script>
